import { Wifi, WifiOff, Settings, TrendingUp, Zap, Network } from "lucide-react";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { useLanguage } from "@/hooks/useLanguage";

const icons = [WifiOff, Settings, TrendingUp, Zap, Network, Wifi];

const OnPremiseBenefitsSection = () => {
  const { ref, isVisible } = useScrollAnimation();
  const { t, tObject } = useLanguage();
  const items = tObject<Array<{ title: string; description: string }>>("onPremisePage.benefits.items");

  return (
    <section ref={ref} className="py-20 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <p className="text-chathero-orange font-semibold text-sm mb-3">{t("onPremisePage.benefits.badge")}</p>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            {t("onPremisePage.benefits.title")}
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            {t("onPremisePage.benefits.intro")}
          </p>
        </div>

        <div className={`grid sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {items.map((item, index) => {
            const Icon = icons[index] || Wifi;
            return (
              <div
                key={index}
                className="bg-background border border-border rounded-2xl p-6 text-center hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
              >
                <div className="w-12 h-12 rounded-xl bg-chathero-mint/10 flex items-center justify-center mx-auto mb-4">
                  <Icon className="w-6 h-6 text-chathero-mint" />
                </div>
                <h3 className="font-bold text-foreground mb-2">{item.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{item.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default OnPremiseBenefitsSection;
